import helper from 'helpers/steinerHelper';

export const actionTypes = helper.createActionTypes('mailTemplateAssoc');
export const actions = helper.createActions('mailTemplateAssoc', actionTypes);